const MAX_ATTEMPTS = 3;
const STALL_TIMEOUT = 20000;
const HARD_TIMEOUT = 45000;
const CHECK_INTERVAL = 5000;
const RETRY_DELAY = 400;

const attempts = new WeakMap();
const pendingSince = new WeakMap();
const lazyPendingSince = new WeakMap();

const isRealSrc = src => !!src && !src.startsWith('data:');
const isPending = img => isRealSrc(img.src) && !img.complete;

const reload = img => {
  const count = attempts.get(img) || 0;

  if (count >= MAX_ATTEMPTS) return;

  const src = img.src;

  attempts.set(img, count + 1);
  pendingSince.delete(img);
  img.removeAttribute('src');

  setTimeout(() => { img.src = src; }, RETRY_DELAY * Math.pow(2, count));
};

const forget = img => {
  attempts.delete(img);
  pendingSince.delete(img);
};

export const checkStalled = (images, now = Date.now(), onStalled = reload) => {
  Array.prototype.forEach.call(images, img => {
    if (!isPending(img)) return forget(img);

    if (!pendingSince.has(img)) return pendingSince.set(img, now);

    const waited = now - pendingSince.get(img);
    const decodedNothing = !img.naturalWidth;

    if (waited > HARD_TIMEOUT || (decodedNothing && waited > STALL_TIMEOUT)) onStalled(img);
  });
};

const retryLazyload = listener => {
  if (listener.attempt < MAX_ATTEMPTS) listener.load();
};

export const checkLazyloadStalled = (queue, now = Date.now(), onStalled = retryLazyload) => {
  queue.forEach(listener => {
    if (!listener.el || listener.el.getAttribute('lazy') !== 'loading') {
      return lazyPendingSince.delete(listener);
    }

    if (!lazyPendingSince.has(listener)) return lazyPendingSince.set(listener, now);

    if (now - lazyPendingSince.get(listener) > HARD_TIMEOUT) {
      lazyPendingSince.delete(listener);
      onStalled(listener);
    }
  });
};

export default function installImageRetry (lazyload) {
  const onEvent = handler => event => {
    const img = event.target;

    if (img && img.tagName === 'IMG' && isRealSrc(img.src)) handler(img);
  };

  document.addEventListener('error', onEvent(reload), true);
  document.addEventListener('load', onEvent(forget), true);

  setInterval(() => {
    checkStalled(document.images);

    if (lazyload) checkLazyloadStalled(lazyload.ListenerQueue);
  }, CHECK_INTERVAL);
}
